"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("@shared/types/environment");
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var EditableWidgets = /** @class */ (function () {
    function EditableWidgets(pageContextManager, rsWidgets, prFlowingPages, env, activeReport, pptxQuillConverter, pageRelativeCoordinates, editableWidgetsIsEnabledService, loggerService, responseCountConverter) {
        this.pageContextManager = pageContextManager;
        this.rsWidgets = rsWidgets;
        this.prFlowingPages = prFlowingPages;
        this.env = env;
        this.activeReport = activeReport;
        this.pptxQuillConverter = pptxQuillConverter;
        this.pageRelativeCoordinates = pageRelativeCoordinates;
        this.editableWidgetsIsEnabledService = editableWidgetsIsEnabledService;
        this.responseCountConverter = responseCountConverter;
        this.logger = loggerService.getLoggerManager('prPptxEditableWidgets');
    }
    EditableWidgets.prototype.getEditableWidgets = function () {
        var _this = this;
        var editablePptxsObjects = [];
        var errors = [];
        var pageElements = document.getElementsByTagName('pr-page');
        var startPageNum = this.pageContextManager.getStartPageNumber();
        var containerId = this.env.get(environment_1.ENV_VARS.CONTAINER_ID);
        lodash_1.default.each(pageElements, function (pageElement, pageIndex) {
            // Typescript thinks that the widgetElements is of type Element[] but it is of type HTMLElement[].
            var widgetElements = Array.from(pageElement.getElementsByTagName('pr-widget'));
            lodash_1.default.each(widgetElements, function (widgetElement) {
                try {
                    // selectionid is widgetId + '.<chunkId>'
                    var selectionid = widgetElement.getAttribute('selectionid') || '';
                    var widgetId = selectionid.split('.')[0];
                    if (!widgetId) {
                        throw Error("Error generating editable pptx widget for selectionid: " + selectionid);
                    }
                    var widget = _this.prFlowingPages.getWidget(widgetId);
                    var pageId = _this.activeReport.getPageIdOfWidget(widget);
                    var widgetScope = _this.rsWidgets.getWidgetScope(widgetId, pageId, containerId);
                    if (_this.editableWidgetsIsEnabledService.isEnabled(widgetScope)) {
                        var genericExportsMeta = _this.getGenericExportsMeta(widgetId, widget._type, startPageNum, pageIndex);
                        editablePptxsObjects.push.apply(editablePptxsObjects, _this.getEditableWidgetHeader(widgetElement, pageElement, genericExportsMeta));
                        editablePptxsObjects.push.apply(editablePptxsObjects, _this.responseCountConverter.getEditableResponseTotals(widgetElement, pageElement, genericExportsMeta));
                        editablePptxsObjects.push.apply(editablePptxsObjects, _this.getEditableWidgetContents(widgetElement, pageElement, genericExportsMeta, widgetScope, widget.layout));
                    }
                }
                catch (error) {
                    errors.push(error);
                }
            });
        });
        if (errors.length > 0) {
            this.logger.error({
                message: 'Errors creating editable pptx widgets',
                // Errors must be stringified so that they are displayed in our
                // server logs.
                errors: errors.map(function (error) {
                    return JSON.stringify(error, Object.getOwnPropertyNames(error));
                }),
                startPageNum: startPageNum,
                containerId: containerId
            });
            this.logger.sendBatch();
        }
        return editablePptxsObjects;
    };
    EditableWidgets.prototype.getEditableWidgetContents = function (widgetElement, pageElement, meta, widgetScope, widgetLayout) {
        var widgetContentsElement = widgetElement.querySelector('.widget-content-wrapper');
        if (widgetContentsElement && (widgetScope === null || widgetScope === void 0 ? void 0 : widgetScope.getEditablePptxObjects)) {
            var coordinates = this.pageRelativeCoordinates.getCoordinates(pageElement, widgetContentsElement);
            var widgetEditablePptxsObjects = widgetScope.getEditablePptxObjects(widgetContentsElement, coordinates, meta, widgetLayout);
            return widgetEditablePptxsObjects;
        }
        return [];
    };
    EditableWidgets.prototype.getEditableWidgetHeader = function (widgetElement, pageElement, meta) {
        var _a;
        var quillEditor = widgetElement.querySelector('.pr-inline-quill-header .ql-editor');
        // When widget titles are removed, they sometimes still exist in widget
        // html but have a width of 0.
        var widgetHeaderExists = quillEditor && ((_a = quillEditor === null || quillEditor === void 0 ? void 0 : quillEditor.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.width) !== 0;
        // Do not create widget header with only whitespace,
        // as this produces empty text widgets which officegen cannot handle
        if (widgetHeaderExists && (quillEditor === null || quillEditor === void 0 ? void 0 : quillEditor.textContent)) {
            var coordinates = this.pageRelativeCoordinates.getCoordinates(pageElement, quillEditor);
            var lines = this.pptxQuillConverter.convertQuillEditorToTextLines(quillEditor);
            if (lines.length > 0) {
                return [{
                        type: "text" /* Text */,
                        widgetOptions: {
                            lines: lines,
                            coordinates: coordinates
                        },
                        meta: meta
                    }];
            }
        }
        return [];
    };
    EditableWidgets.prototype.getGenericExportsMeta = function (id, type, startPageNum, pageIndex) {
        return {
            _id: id,
            _type: type || '',
            page: startPageNum + pageIndex
        };
    };
    EditableWidgets.$inject = [
        'pr.pageContextManager',
        'rsWidgets',
        'prFlowingPages',
        'rsEnvironment',
        'prActiveReport',
        'prPptxQuillConverter',
        'prPageRelativeCoordinates',
        'prPptxEditableWidgetIsEnabled',
        'pr.loggerService',
        'prPptxResponseCountConverter'
    ];
    return EditableWidgets;
}());
(function (angularModule) {
    angularModule.service('prPptxEditableWidgets', EditableWidgets);
})(angular.module('qualtrics.pr'));
